import { trackEvent } from "./trackEvent.ts";

export const vTracking = {
  mounted: (element: HTMLElement) => {
    if (import.meta.env.VITE_STAGE === "prod") {
      element.addEventListener("click", function (event: PointerEvent) {
        if (!(event.target instanceof HTMLElement)) {
          return;
        }

        if (event.target.dataset.trackingid) {
          trackEvent(event.target.dataset.trackingid);
        }
      });
    }
  },
};
